import React, { memo, useContext } from 'react';
import { Footer as MastheadFooter } from '@spotify-internal/masthead-react';
import EmbeddedContext from '../../configuration/context/embedded';
export function Footer(props) {
    const { isEmbedded } = useContext(EmbeddedContext);
    return isEmbedded ? React.createElement(React.Fragment, null) : React.createElement(MastheadFooter, Object.assign({}, props));
}
export default memo(Footer);
//# sourceMappingURL=footer.js.map